import DetailContext from '@shared/components/utils/context/detailContext';
import DetailDate from '@components/elements/detail/detailDate';
import DetailEventTitle from '@components/atoms/text/detailEventTitle';
import DetailText from '@components/atoms/text/detailText';
import { useContext } from 'react';

export default function DetailEvent() {
  const { assetInfo } = useContext(DetailContext);

  if (assetInfo) {
    const { channelTitle, eventInfo, eventTitle } = assetInfo;
    return (
      <>
        <DetailText id='channelTitle'>{channelTitle}</DetailText>
        <DetailText id='eventInfo'>{eventInfo}</DetailText>
        <DetailEventTitle id='eventTitle'>{eventTitle}</DetailEventTitle>
        <DetailDate />
      </>
    );
  }
}
